import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { cn } from '@/lib/utils';

interface TeamLogoProps {
  teamName?: string;
  logoUrl?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

export const TeamLogo = ({ teamName, logoUrl, size = 'md', className }: TeamLogoProps) => {
  const sizeClasses = {
    sm: 'h-6 w-6',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
    xl: 'h-16 w-16'
  };

  const getInitials = (name?: string) => {
    if (!name) return 'T';
    return name
      .split(' ')
      .map(word => word[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  return (
    <Avatar className={cn(sizeClasses[size], className)}>
      <AvatarImage src={logoUrl} alt={`${teamName} logo`} />
      <AvatarFallback className="bg-primary text-primary-foreground font-semibold text-sm">
        {getInitials(teamName)}
      </AvatarFallback>
    </Avatar>
  );
};